export default __webpack_public_path__ + "static/mhealth-app-development-company-peerbits-bc8397f1ffdfec24c2660347718e79d1.png";